
function stringExpires(second=0, minute=0, hour=0, day=0) {
    const dayToSecond = day*24*60*60;
    const hourToSecond = hour*60*60;
    const minuteToSecond = minute*60;
    
    const date = new Date();
    date.setTime(date.getTime() + (dayToSecond + hourToSecond + minuteToSecond + second) * 1000);
    
    return date.toUTCString();
}


function setCookie(name = "cookieName", value = "cookieValue", optionObj) {

    // 設置cookie的name及value
    var setCookieString = name + "=" + encodeURIComponent(value);

    // 設置cookie其他屬性
    if (typeof (optionObj) === "object") {
        if (optionObj["path"] !== undefined) {
            setCookieString = setCookieString + `; path=${optionObj["path"]}`;
        }
        if (optionObj["expires"] !== undefined) {
            setCookieString = setCookieString + `; expires=${optionObj["expires"].toUTCString()}`;
        }
        if (optionObj["domain"] !== undefined) {
            setCookieString = setCookieString + `; domain=${optionObj["domain"]}`;
        }
        if (optionObj["max-age"] !== undefined) {
            setCookieString = setCookieString + `; max-age=${optionObj["max-age"]}`;
        }
    }

    // 設置cookie
    document.cookie = setCookieString;
}


/**
 * 依照cookie的name取得value並回傳
 * 有找到則回傳value，沒有找到則回傳false(不回傳空值是因為有些cookie可能為空)
 */
function getCookie(name) {
    var cookieArray = document.cookie.split(";");
    for (var index = 0; index < cookieArray.length; index++) {
        let cookiePair = cookieArray[index].trim().split("=");
        if (cookiePair[0] === name) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return false;
}


/**
 * 確認瀏覽器是否可以記錄cookie
 */
function isBrowserCanSetCookie() {
    console.log(window.navigator.cookieEnabled);
}


/**
 * 通用型Cookie屬性
 */
function commonCookieAttrObj() {
    return {
        path : '/',
        expires : new Date(new Date().getTime()+20*365*24*60*60*1000),
        domain : process.env.VUE_APP_COOKIE_ATTRIBUTE_DOMAIN
    }
}


/**
 * 通用型設置Cookie
 */
function commonSetCookie(name = "cookieName", value = "cookieValue") {
    setCookie(name, value, commonCookieAttrObj());
}


/**
 * 通用型刪除Cookie
 */
function commonDeleteCookie(name = "cookieName") {
    let cookieAttrObj = commonCookieAttrObj();
    cookieAttrObj.expires = new Date(new Date().getTime()-1000);
    setCookie(name, "", cookieAttrObj);
}


/**
 * 帳號登出刪除cookie
 */
function logoutAccount() {
    let cookieAttrObj = commonCookieAttrObj();
    cookieAttrObj.expires = new Date(new Date().getTime()-1000);
    setCookie(process.env.VUE_APP_COOKIE_ACCOUNT, "", cookieAttrObj);
    setCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE, "", cookieAttrObj);
    setCookie(process.env.VUE_APP_COOKIE_OPEN_ID_ACTION, "", cookieAttrObj);
}


export default { setCookie, getCookie, isBrowserCanSetCookie, commonCookieAttrObj, commonSetCookie, commonDeleteCookie, logoutAccount }